import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentAddedDocumentDto extends EpimsBaseEntityDto {
    
 EventTypeId: string;
 PathURL: string;
 Title: string;  
    
 IncidentTrackingNo: string;

 FileType: string;
    

}